import { useEffect, useState } from 'react';
import rison from 'rison';
import { getChartListAPI } from '../../../api/chart';
import moment from 'moment/moment';
import { getDashboardListAPI } from '../../../api/dashboard';
import { getChatHistoryListAPI } from '../../../api/conversation';
import { useHistory } from 'react-router-dom';
import ListView from '../components/ListView';

const RecentView = ({ user, setShowChartPreview, setSliceId }) => {
  const [activeTab, setActiveTab] = useState(1);
  const tabs = [
    { label: '已查看', value: 1 },
    { label: '已编辑', value: 2 },
    { label: '已创建', value: 3 },
  ];
  const tabChange = tab => {
    if (tab === activeTab) return;
    setActiveTab(tab);
    let filters = [];
    if (tab === 1) {
      filters = [];
    }
    if (tab === 2) {
      filters = [
        {
          col: 'changed_by',
          opr: 'rel_o_m',
          value: '1',
        },
      ];
    }
    if (tab === 3) {
      filters = [
        {
          col: 'created_by',
          opr: 'rel_o_m',
          value: '1',
        },
      ];
    }
    getList({ chartFilters: filters, dashboardFilters: filters });
  };
  const [type, setType] = useState('list');
  const [list, setList] = useState([]);
  const getChartList = async (filters = []) => {
    const q = rison.encode({
      order_column: 'changed_on_delta_humanized',
      order_direction: 'desc',
      page: 0,
      page_size: 4,
      filters,
    });
    const {
      json: { result },
    } = await getChartListAPI({ q });
    return result.map(r => ({
      ...r,
      title: r.slice_name,
      date: moment(r.changed_on_utc).format('YYYY-MM-DD HH:mm'),
      itemType: 'chart',
    }));
  };
  const getDashboardList = async (filters = []) => {
    const q = rison.encode({
      order_column: 'changed_on_delta_humanized',
      order_direction: 'desc',
      page: 0,
      page_size: 4,
      filters,
    });
    const {
      json: { result },
    } = await getDashboardListAPI({ q });
    return result.map(r => ({
      ...r,
      title: r.dashboard_title,
      date: moment(r.changed_on_utc).format('YYYY-MM-DD HH:mm'),
      itemType: 'dashboard',
    }));
  };
  const getChatList = async () => {
    const {
      json: { result: { result } },
    } = await getChatHistoryListAPI({
      user_id: user.userId,
      page: 1,
      page_size: 4,
    });
    return result.map(r => ({
      ...r,
      date: moment(r.changed_on_utc).format('YYYY-MM-DD HH:mm'),
      itemType: 'chat',
    }));
  };
  const sortedList = (list, count) => {
    // 排序（按 date 降序）
    list.sort((a, b) => moment(b.date).valueOf() - moment(a.date).valueOf());

    // 截取前 count 条
    return list.slice(0, count);
  };
  /**
   * 获取最近的列表
   * @returns {Promise<void>}
   */
  const getList = async (
    { chartFilters, dashboardFilters } = {
      chartFilters: [],
      dashboardFilters: [],
    },
  ) => {
    setList([]);
    const [chartList, dashboardList, chatList] = await Promise.all([
      getChartList(chartFilters),
      getDashboardList(dashboardFilters),
      getChatList(),
    ]);
    const list = sortedList([...chartList, ...dashboardList, ...chatList], 4);
    setList(list);
  };
  useEffect(() => {
    getList();
  }, []);

  const history = useHistory();
  const onDetail = item => {
    if (item.itemType === 'chart') {
      setSliceId(item.id);
      setShowChartPreview(true);
    }
    if (item.itemType === 'dashboard') {
      history.push(`/aibi/dashboard/${item.id}/`);
    }
    if (item.itemType === 'chat') {
      history.push(`/chat`);
    }
  };
  return (
    <ListView
      title="最近"
      activeTab={activeTab}
      tabs={tabs}
      tabChange={tabChange}
      list={list}
      type={type}
      onDetail={onDetail}
      onTypeChange={type => setType(type)}
    />
  );
};

export default RecentView;
